import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  Link,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import CloseIcon from "src/assets/svg-icons/close.svg";
import CarIcon from "src/assets/svg-icons/car.svg";
import moment from "moment";
import InfoItem from "../info-item";
import ArrowsIcon from "src/assets/svg-icons/colored-circular-arrowsd.svg";
import { ReactComponent as EmployeesIcon } from "src/assets/svg-icons/side-bar/employees.svg";
import { ReactComponent as CustomersIcon } from "src/assets/svg-icons/side-bar/customers.svg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import InvoicePopup from "../invoice-popup";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import Lightbox from "yet-another-react-lightbox";
import { useState } from "react";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Download from "yet-another-react-lightbox/plugins/download";
import Video from "yet-another-react-lightbox/plugins/video";
import { isMediaUrlVideo } from "src/utils";

interface IProps {
  open: boolean;
  onClose: any;
  transDetails: any;
}

const TransactionsDetailsDrawer = ({ open, onClose, transDetails }: IProps) => {
  const [openGallery, setOpenGallery] = useState(false);

  const checkInEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "checkin",
  );
  const checkOutEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "checkout",
  );
  const vehicleIsReadyEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "vehicleisready",
  );
  const editEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "edit",
  );
  const paymentEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "payment",
  );
  const noShowEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "noshow",
  );
  const validatedEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "validation",
  );
  const carWashEmployee = transDetails?.involvedEmployees?.find(
    (item: any) => item.operationType === "inProgress",
  );

  console.log({ transDetails });

  return (
    <Drawer anchor={"right"} open={open} onClose={onClose}>
      <Box
        minWidth={{ xs: "100vw", md: "570px" }}
        maxWidth={{ xs: "100vw", md: "570px" }}
        padding={"40px 30px"}
      >
        {/* header */}
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          borderBottom={"1px solid #454343"}
          paddingBottom={"29px"}
        >
          <Typography>Transaction Details</Typography>
          <IconButton sx={{ p: "0" }} onClick={onClose}>
            <img src={CloseIcon} alt="" />
          </IconButton>
        </Stack>
        {/* content */}
        <Box paddingY={"26px"}>
          <Stack gap={2.5}>
            {/* ticket details */}
            <InfoItem label="#Ticket-Num" value={transDetails.ticketNumber} />
            <InfoItem
              label="Location"
              value={`${
                transDetails?.clientName ? `${transDetails?.clientName} -` : ""
              } ${transDetails.locationName ?? "--"}`}
            />
            <InfoItem label="Service" value={transDetails.service?.name} />

            <Grid container spacing={1}>
              <Grid item xs={12} sm={7}>
                <InfoItem
                  label="Total Parking Fees"
                  value={
                    transDetails.totalPrice >= 0
                      ? `${transDetails.totalPrice}`
                      : "--"
                  }
                  isMoney
                  description={
                    transDetails?.validated
                      ? "(Validated)"
                      : transDetails?.hasGlobalDiscount &&
                          transDetails.totalPrice > 0
                        ? `(%${transDetails?.globalDiscountPer} Discount is applied)`
                        : transDetails?.discountType === "barberShopFS"
                          ? "(Discounted)"
                          : ""
                  }
                />
              </Grid>
              {transDetails.qyodInvoicePdfUrl && (
                <Grid item xs={12} sm={4}>
                  <Box>
                    <Typography
                      fontWeight={600}
                      fontSize={{ xs: "12px", md: "15px" }}
                      mb={0.5}
                    >
                      Tax Invoice
                    </Typography>
                    <InvoicePopup
                      url={transDetails.qyodInvoicePdfUrl}
                      invoiceId={transDetails.qyodReferenceNumber}
                    />
                  </Box>
                </Grid>
              )}
            </Grid>

            {(transDetails.paymentDetails || [])
              .filter((payment: any) => !!payment) // to avoid null weird case
              .map((payment: any, index: number) => (
                <Grid key={payment.id} container spacing={2}>
                  <Grid item xs={4} sm={3}>
                    <InfoItem
                      label={`Paid Fees ${index > 0 ? index + 1 : ""}`}
                      value={payment?.amount >= 0 ? `${payment.amount}` : "--"}
                      isMoney
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <InfoItem
                      label="Payment Time"
                      value={
                        payment?.time
                          ? moment(payment.time).format("DD-MM-YY hh:mm A")
                          : "--"
                      }
                    />
                  </Grid>
                  <Grid item xs={4} sm={2.5}>
                    <InfoItem
                      label="Method"
                      value={
                        payment?.paymentMethod
                          ? payment.paymentMethod.charAt(0).toUpperCase() +
                            payment.paymentMethod.slice(1)
                          : "--"
                      }
                    />
                  </Grid>
                  <Grid item xs={4} sm={2.5}>
                    {payment?.receiptUrl ? (
                      <Box>
                        <Typography fontWeight={600} mb={0.1}>
                          Receipt
                        </Typography>
                        <Link
                          href={payment?.receiptUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </Link>
                      </Box>
                    ) : null}
                  </Grid>
                </Grid>
              ))}

            {transDetails?.freeReason ? (
              <InfoItem label="Free Reason" value={transDetails?.freeReason} />
            ) : null}
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <InfoItem
                  label="Booking Date"
                  value={
                    transDetails.arrivalTime
                      ? moment(transDetails.arrivalTime).format("D/M/YYYY")
                      : "--"
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Booking Time"
                  value={
                    transDetails.arrivalTime
                      ? moment(transDetails.arrivalTime).format("h:mm A")
                      : "--"
                  }
                />
              </Grid>
            </Grid>
            {/* checking time  */}
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <InfoItem
                  label="Check-in Date"
                  value={
                    transDetails.checkInTime
                      ? moment(transDetails.checkInTime).format("D/M/YYYY")
                      : "--"
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Check-in Time"
                  value={
                    transDetails.checkInTime
                      ? moment(transDetails.checkInTime).format("h:mm A")
                      : "--"
                  }
                />
              </Grid>
            </Grid>
            {/* validated date and time */}
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <InfoItem
                  label="Validated Date"
                  value={
                    transDetails.validatedAt
                      ? moment(transDetails.validatedAt).format("D/M/YYYY")
                      : "--"
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Validated Time"
                  value={
                    transDetails.validatedAt
                      ? moment(transDetails.validatedAt).format("h:mm A")
                      : "--"
                  }
                />
              </Grid>
            </Grid>
            {/* request date and time */}
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <InfoItem
                  label="Requested Date"
                  value={
                    transDetails.carPreprationRequestTime
                      ? moment(transDetails.carPreprationRequestTime).format(
                          "D/M/YYYY",
                        )
                      : "--"
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Requested Time"
                  value={
                    transDetails.carPreprationRequestTime
                      ? moment(transDetails.carPreprationRequestTime).format(
                          "h:mm A",
                        )
                      : "--"
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <InfoItem
                  label="Check-out Date"
                  value={
                    transDetails.checkOutTime
                      ? moment(transDetails.checkOutTime).format("D/M/YYYY")
                      : "--"
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Check-out Time"
                  value={
                    transDetails.checkOutTime
                      ? moment(transDetails.checkOutTime).format("h:mm A")
                      : "--"
                  }
                />
              </Grid>
            </Grid>
            {transDetails.editReason && (
              <InfoItem label="Edit Reason" value={transDetails.editReason} />
            )}

            <Box bgcolor={"#454343"} height={"1px"} width={"100%"} />
            {/* car details */}
            <Stack direction={"row"} gap={1}>
              <img src={CarIcon} alt="" />
              <Typography>Car Details</Typography>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={4}>
                <InfoItem
                  label="#Plate-Num"
                  value={
                    transDetails.plateInfo &&
                    (!!transDetails.plateInfo?.letters ||
                      transDetails.plateInfo?.numbers)
                      ? `${transDetails.plateInfo?.letters || ""}${
                          transDetails.plateInfo?.numbers || ""
                        }`
                      : "--"
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Brand"
                  value={transDetails.carInfo?.brandNameEn || "--"}
                />
              </Grid>
              <Grid item xs={4}>
                <InfoItem
                  label="Car Color"
                  value={transDetails.carInfo?.colorNameEn || "--"}
                />
              </Grid>
              <Grid item xs={12}>
                <InfoItem
                  label="Vehicle Description"
                  value={transDetails.carInfo?.description || "--"}
                />
              </Grid>
            </Grid>
            <Stack direction={"row"} gap={1}>
              <CollectionsOutlinedIcon color="primary" />
              <Typography>Galley</Typography>
            </Stack>
            {transDetails?.carInfo?.media?.length > 0 ? (
              <Button
                sx={{ width: "fit-content" }}
                size="small"
                variant="outlined"
                onClick={() => setOpenGallery(true)}
              >
                View Gallery
              </Button>
            ) : (
              <Typography color={"#ACA8A8"} fontWeight={600}>
                No Media
              </Typography>
            )}
            <Lightbox
              open={openGallery}
              plugins={[Thumbnails, Counter, Download, Video]}
              close={() => setOpenGallery(false)}
              slides={(transDetails?.carInfo?.media || [])?.map(
                (item: string) =>
                  isMediaUrlVideo(item)
                    ? {
                        type: "video",
                        sources: [
                          {
                            src: item,
                            type: "video/mp4",
                          },
                        ],
                        autoPlay: false,
                        controls: true,
                        disablePictureInPicture: true,
                      }
                    : {
                        src: item,
                      },
              )}
              carousel={{
                finite: true,
              }}
            />

            <Box bgcolor={"#454343"} height={"1px"} width={"100%"} />
            {transDetails.service?.type === "valet" ? (
              <>
                {/* customer details */}
                <Stack direction={"row"} gap={1}>
                  <SvgIcon color="primary">
                    <CustomersIcon />
                  </SvgIcon>
                  <Typography>Customer Details</Typography>
                </Stack>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InfoItem
                      label="Name"
                      value={transDetails.customerName || "--"}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <InfoItem
                      label="Mobile Number"
                      value={
                        transDetails.customerNumber?.mobile
                          ? `${
                              transDetails.customerNumber?.countryCode ?? ""
                            } ${
                              transDetails.customerNumber?.mobile?.length > 20
                                ? transDetails.customerNumber?.mobile.substring(
                                    0,
                                    20,
                                  ) + "..."
                                : transDetails.customerNumber?.mobile
                            }`
                          : "--"
                      }
                    />
                  </Grid>
                </Grid>

                <Box bgcolor={"#454343"} height={"1px"} width={"100%"} />
              </>
            ) : null}

            <Stack direction={"row"} gap={1}>
              <SvgIcon color="primary">
                <EmployeesIcon />
              </SvgIcon>
              <Typography>Employees Details</Typography>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <InfoItem label="Booking Employee" value={"--"} />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="Check-in Employee"
                  value={checkInEmployee?.userNameEn || "--"}
                />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="Validation Employee"
                  value={validatedEmployee?.userNameEn || "--"}
                />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="Vehicle is Ready Employee"
                  value={vehicleIsReadyEmployee?.userNameEn || "--"}
                />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="Car Wash Employee"
                  value={carWashEmployee?.userNameEn || "--"}
                />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="Payment Employee"
                  value={paymentEmployee?.userNameEn || "--"}
                />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="Check-out Employee"
                  value={checkOutEmployee?.userNameEn || "--"}
                />
              </Grid>

              <Grid item xs={6}>
                <InfoItem
                  label="No Show Employee"
                  value={noShowEmployee?.userNameEn || "--"}
                />
              </Grid>
            </Grid>

            {transDetails?.changeLog?.length > 0 ? (
              <>
                <Box bgcolor={"#454343"} height={"1px"} width={"100%"} />
                <Stack direction={"row"} gap={1}>
                  <img src={ArrowsIcon} alt="" />
                  <Typography>Edit History</Typography>
                </Stack>
                {transDetails?.changeLog?.map((log: any) => {
                  return (
                    <Box
                      key={log.changedAt}
                      border={"1px solid gray"}
                      borderRadius={"8px"}
                      p={1.5}
                    >
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        gap={1}
                      >
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                          <AccessTimeIcon
                            sx={{ opacity: "0.6" }}
                            fontSize="small"
                          />
                          <Typography fontSize={"13px"}>
                            {moment(log.changedAt).format(
                              "MMMM D, YYYY hh:mm A",
                            )}
                          </Typography>{" "}
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"}>
                          <PersonOutlineOutlinedIcon
                            sx={{ opacity: "0.6" }}
                            fontSize="small"
                          />
                          <Typography fontSize={"13px"}>
                            {log.userName ?? "--"}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Box
                        bgcolor={"#454343"}
                        height={"1px"}
                        width={"100%"}
                        my={1.5}
                      />
                      <Stack mb={1.5}>
                        <Typography>
                          <Typography
                            component={"span"}
                            fontSize={"14px"}
                            sx={{ opacity: "0.6" }}
                          >
                            Edit Reason:{" "}
                          </Typography>

                          <Typography
                            sx={{ opacity: "0.8" }}
                            component={"span"}
                            fontSize={"14px"}
                          >
                            "{log?.editReason}"
                          </Typography>
                        </Typography>
                      </Stack>
                      <Stack gap={1.1}>
                        {log.changes?.map((change: any) => {
                          return (
                            <Box
                              key={change.field}
                              borderRadius={"6px"}
                              p={1.1}
                              boxShadow={
                                "0px 14px 44px 0px rgba(0, 0, 0, 0.35)"
                              }
                              bgcolor={"#292828"}
                            >
                              <Grid container>
                                <Grid item xs={4}>
                                  <Typography
                                    fontSize={"13px"}
                                    sx={{ opacity: "0.6" }}
                                  >
                                    Field:
                                  </Typography>
                                  <Typography fontSize={"13px"}>
                                    {change.label}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography
                                    fontSize={"12px"}
                                    sx={{ opacity: "0.6" }}
                                  >
                                    From:
                                  </Typography>
                                  {change.field.includes("media") ? (
                                    <Stack>
                                      {change.oldValue.map((value: string) => {
                                        return (
                                          <Link
                                            key={value}
                                            href={value}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                              fontSize: "13px",
                                              fontWeight: "500",
                                            }}
                                          >
                                            View Media
                                          </Link>
                                        );
                                      })}
                                      {change.oldValue.length === 0 && "--"}
                                    </Stack>
                                  ) : change.field === "paymentDetails" ? (
                                    <>
                                      {change.oldValue.map(
                                        (item: any, index: number) => {
                                          return (
                                            <Stack
                                              key={`${item.amount}_${index}`}
                                            >
                                              <Typography
                                                fontSize={"13px"}
                                                textTransform={"capitalize"}
                                              >
                                                Method: {item.paymentMethod}
                                              </Typography>
                                              <Typography fontSize={"13px"}>
                                                Amount: {item.amount}
                                              </Typography>
                                              {index <
                                              change.oldValue.length - 1 ? (
                                                <Box
                                                  bgcolor={"#454343"}
                                                  height={"2px"}
                                                  width={"80px"}
                                                />
                                              ) : null}
                                            </Stack>
                                          );
                                        },
                                      )}
                                    </>
                                  ) : (
                                    <Typography fontSize={"13px"}>
                                      {change.oldValue || "--"}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography
                                    fontSize={"12px"}
                                    sx={{ opacity: "0.6" }}
                                  >
                                    To:
                                  </Typography>
                                  {change.field.includes("media") ? (
                                    <Stack gap={0.2}>
                                      {change.newValue.map((value: string) => {
                                        return (
                                          <Link
                                            key={value}
                                            href={value}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                              fontSize: "13px",
                                              fontWeight: "500",
                                            }}
                                          >
                                            View Media
                                          </Link>
                                        );
                                      })}
                                      {change.newValue.length === 0 && "--"}
                                    </Stack>
                                  ) : change.field === "paymentDetails" ? (
                                    <>
                                      {change.newValue.map(
                                        (item: any, index: number) => {
                                          return (
                                            <Stack
                                              key={`${item.amount}_${index}`}
                                            >
                                              <Typography
                                                fontSize={"13px"}
                                                textTransform={"capitalize"}
                                              >
                                                Method: {item.paymentMethod}
                                              </Typography>
                                              <Typography fontSize={"13px"}>
                                                Amount: {item.amount}
                                              </Typography>
                                              {index <
                                              change.newValue.length - 1 ? (
                                                <Box
                                                  bgcolor={"#454343"}
                                                  height={"2px"}
                                                  width={"80px"}
                                                />
                                              ) : null}
                                            </Stack>
                                          );
                                        },
                                      )}
                                    </>
                                  ) : (
                                    <Typography fontSize={"13px"}>
                                      {change.newValue || "--"}
                                    </Typography>
                                  )}
                                </Grid>
                              </Grid>
                            </Box>
                          );
                        })}
                      </Stack>
                    </Box>
                  );
                })}
              </>
            ) : null}
          </Stack>
        </Box>
      </Box>
    </Drawer>
  );
};

export default TransactionsDetailsDrawer;
